import React from 'react';
import { Modal } from 'react-bootstrap';
import api from '../../utils/api';

class UserModerationForm extends React.Component {

    state = {
        days: null,
        originalDays: null,
        isBlocked: false,
        isShadowBan: false
    };

    componentDidMount() {

        this.props.changeCover(true, () => {

            api.getBlockedUser({
                projectId: this.props.projectId,
                name: this.props.commentName
            })
                .then(({ data: { days, isShadowBan } }) => {

                    return new Promise(resolve => {

                        if (days === undefined) {
                            return this.setState({ isBlocked: false }, resolve);
                        }

                        this.setState({
                            days,
                            originalDays: days,
                            isBlocked: true,
                            isShadowBan: !!isShadowBan
                        }, resolve);
                    });
                })
                .then(() => {

                    this.props.changeCover(false);
                });
        });
    }

    onChangeDays = ({ currentTarget: { value: days } }) => {

        this.setState({ days: days === '' ? null : parseInt(days.slice(0, 3)) });
    };

    onChangeShadowBan = ({ currentTarget: { value } }) => {

        this.setState({ isShadowBan: !!value });
    };

    onBlock = e => {

        e.preventDefault();

        this.props.changeCover(true, () => {

            return api.blockUser({
                projectId: this.props.projectId,
                name: this.props.commentName,
                days: this.state.days,
                isShadowBan: this.state.isShadowBan
            })
                .then(({ data: { days, isShadowBan } }) => {

                    return new Promise(resolve => {

                        this.setState({ isBlocked: true, originalDays: days }, resolve);
                    });
                })
                .then(() => this.props.changeCover(false));
        });

    };

    onUnblock = () => {

        this.props.changeCover(true, () => {

            return api.unblockUser({
                projectId: this.props.projectId,
                name: this.props.commentName
            })
                .then(() => {

                    return new Promise(resolve => {

                        this.setState({ isBlocked: false, originalDays: null }, resolve);
                    });
                })
                .then(() => this.props.changeCover(false));
        });

    };

    get message() {

        let message = 'This user is not blocked';

        if (this.state.isBlocked) {

            message = 'This user is blocked';

            if (Number.isFinite(this.state.originalDays)) {
                message+= ` for ${this.state.originalDays} day`;
                if (this.state.originalDays !== 0) {
                    message+= 's';
                }
            } else {
                message+= ' forever';
            }
        }
        message+= '.';

        return message;
    }

    get shadowBan() {

        if (!this.props.isModerationPlus) {
            return null;
        }
        return (
            <div className="form-group">

                <label>
                    Should they be aware that they are blocked?
                </label>

                <div className="radio">
                    <label>
                        <input
                            type="radio"
                            name="shadow_ban"
                            value="1"
                            checked={this.state.isShadowBan}
                            onChange={this.onChangeShadowBan}
                        />
                        No
                    </label>
                </div>

                <div className="radio">
                    <label>
                        <input
                            type="radio"
                            name="shadow_ban"
                            value=""
                            checked={!this.state.isShadowBan}
                            onChange={this.onChangeShadowBan}
                        />
                        Yes
                    </label>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="user-moderation-form">
                <Modal show={true} bsSize="small">

                    <Modal.Header closeButton onHide={this.props.onHide}>
                        <Modal.Title>User Moderation</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <form onSubmit={this.onBlock}>

                            <div className="well text-center">{this.message}</div>

                            <div className="form-group">

                                <label>Block this user</label>

                                <div className="radio">
                                    <label>
                                        <input
                                            type="radio"
                                            name="block_option"
                                            value=""
                                            checked={!this.state.days}
                                            onChange={this.onChangeDays}
                                        />
                                        Forever
                                    </label>
                                </div>

                                <div className="radio">

                                    <label>

                                        <input
                                            type="radio"
                                            name="block_option"
                                            value="5"
                                            checked={!!this.state.days}
                                            onChange={this.onChangeDays}
                                            style={{marginTop: 11}}
                                        />

                                        For <input
                                        type="number"
                                        step="1"
                                        placeholder="0"
                                        min="0"
                                        max="100"
                                        value={this.state.days === null ? 0 : (this.state.days + '')}
                                        className="form-control"
                                        onChange={this.onChangeDays}
                                        style={{ display: 'inline-block', width: '5em', textAlign: 'center' }}
                                    /> days

                                    </label>

                                </div>

                            </div>

                            {this.shadowBan}

                            <hr />

                            <div className="form-group">

                                <button
                                    className="btn btn-success btn-block"
                                    type="submit"
                                >
                                    {this.state.isBlocked ? 'Update' : 'Block'}
                                </button>
                            </div>

                            {this.state.isBlocked ? (
                                <div className="form-group">
                                    <button
                                        className="btn btn-default btn-block"
                                        type="button"
                                        onClick={this.onUnblock}
                                    >
                                        Unblock
                                    </button>
                                </div>
                            ) : null}

                        </form>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default UserModerationForm;


// WEBPACK FOOTER //
// ./src/components/projects/UserModerationForm.jsx